import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FilterList from '../../filterlist/FilterList';
import defaultSyles from './FilterDefaultsModal.module.scss';
import filterDefinitionsPropType from '../../filterDefinitionsPropType';

class FilterDefaultsModal extends Component {
    constructor(props) {
        super(props);

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.closeControl();
        }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    render() {
        const { styles } = this.props;
        return this.props.isOpen ? (
            <div className="filter-defaults-modal shadow" ref={ this.setWrapperRef }>
                <div className={ styles['filter-defaults-modal-inner'] }>
                    <div className={ styles.title }>
                        Choose Default Filters
                    </div>
                    <div className={ styles.body }>
                        <FilterList
                            isDefaults
                            filters={ this.props.defaultFilters }
                            filterDefinitions={ this.props.filterDefinitions }
                            currentlyOpenFilter={ this.props.currentlyOpenDefaultFilter }
                            openFilter={ this.props.openDefaultFilter }
                            closeFilter={ this.props.closeDefaultFilter }
                            addFilter={ this.props.addDefaultFilter }
                            removeFilter={ this.props.removeDefaultFilter }
                            updateFilter={ this.props.updateDefaultFilter }
                            getAvailableListValues={ this.props.getAvailableListValues }
                        />
                    </div>
                </div>
            </div>
        ) : null;
    }
}

FilterDefaultsModal.propTypes = {
    defaultFilters: PropTypes.arrayOf(PropTypes.shape({})),
    filterDefinitions: filterDefinitionsPropType.isRequired,
    isOpen: PropTypes.bool,
    closeControl: PropTypes.func.isRequired,
    openDefaultFilter: PropTypes.func.isRequired,
    closeDefaultFilter: PropTypes.func.isRequired,
    addDefaultFilter: PropTypes.func.isRequired,
    removeDefaultFilter: PropTypes.func.isRequired,
    updateDefaultFilter: PropTypes.func.isRequired,
    currentlyOpenDefaultFilter: PropTypes.string,
    getAvailableListValues: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string)
};

FilterDefaultsModal.defaultProps = {
    defaultFilters: [],
    isOpen: false,
    currentlyOpenDefaultFilter: null,
    styles: defaultSyles
};

export default FilterDefaultsModal;
